<div [class.show]="show" class="record-details-widget-container" *ngIf="widgetData$ | async">
  <div (click)="close()" class="widget-background"></div>

  <div tabindex="-1" class="record-details-widget" [class.with-location]="inventoryLocationsEnabled">
    <div class="fixed-wrapper" #fixedWrapper>
      <div class="header-container" [ngClass]="{'border-bottom-width': !widgetData?.pendingTransaction}">
        <div class="header">
          Transaction Details
          <div class="sub-header flex flex-row">
            <div class="flex flex-row">
              Performed:
              <app-edit-transaction-date class="ml-1" *ngIf="canUpdateTransactionDate(); else performedSimpleText"
                [date]="mostRecentData?.transactionDate"
                (dateSelected)="updateTransactionDate($event)"
                #editTransactionDateComponent>
              </app-edit-transaction-date>
              <ng-template #performedSimpleText>{{mostRecentData?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}</ng-template>
              <div *ngIf="mostRecentData?.isTransactionDateUpdated"
                class="history-container" (click)="onHistoryClick()">
                <app-tooltip [template]="historyIconTooltip " 
                    customClasses="!bg-[#3b4b61] after:hidden text-sm !top-[24px] !left-[3px]" 
                    staticPosition="bottom" [width]="65"
                >
                     <div class="icon-history">
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.5 0C4.81 0 3.20125 0.661781 1.99591 1.82772L0.693469 0.525281C0.615875 0.447688 0.511875 0.40625 0.40625 0.40625C0.353844 0.40625 0.301031 0.416 0.250656 0.437125C0.0987187 0.499687 0 0.648375 0 0.8125V4.46875C0 4.69341 0.181594 4.875 0.40625 4.875H4.0625C4.22662 4.875 4.37531 4.77628 4.43787 4.62434C4.50084 4.47241 4.46591 4.29772 4.34972 4.18153L3.13991 2.97172C4.043 2.11006 5.24062 1.625 6.5 1.625C9.18816 1.625 11.375 3.81184 11.375 6.5C11.375 9.18816 9.18816 11.375 6.5 11.375C3.96744 11.375 1.83219 9.39859 1.63922 6.87537C1.62297 6.66331 1.44666 6.5 1.23419 6.5H0.419656C0.307531 6.5 0.199875 6.54631 0.123094 6.62838C0.0467188 6.71044 0.0073125 6.82094 0.0142188 6.93306C0.239688 10.335 3.08831 13 6.5 13C10.0839 13 13 10.0839 13 6.5C13 2.91606 10.0839 0 6.5 0Z" fill="#9CA3AF"/>
                            <path d="M8.73438 5.6875H7.3125V3.04688C7.3125 2.93475 7.2215 2.84375 7.10938 2.84375H5.89062C5.7785 2.84375 5.6875 2.93475 5.6875 3.04688V7.10938C5.6875 7.2215 5.7785 7.3125 5.89062 7.3125H8.73438C8.8465 7.3125 8.9375 7.2215 8.9375 7.10938V5.89062C8.9375 5.7785 8.8465 5.6875 8.73438 5.6875Z" fill="#9CA3AF"/>
                        </svg>   
                    </div>
                </app-tooltip>
            </div>  
          </div>
          <ng-template #historyIconTooltip>History</ng-template>
          <ng-template #editIconTooltip>Edit</ng-template>
          <span class="vertical-divider"> | </span> 
          <div>
              Recorded: {{ mostRecentActivityDate | formattedDate: 'MMM d a, HH:mm yyyy'}} 
          </div>
          <span class="vertical-divider"> | </span>
          <div>
            {{mostRecentActivityUserFirstName}}
            <ng-container
              *ngIf="mostRecentActivityUserLastName">{{mostRecentActivityUserLastName[0]}}.
            </ng-container>
          </div>
        </div>
      </div>

        <img (click)="close()"
             class="close-icon animation-focus-default"
             src="assets/icons/icon-close-thin.svg"
             alt="close-icon"
        />
      </div>

      <div class="card" *ngIf="pendingTransactions?.length">
        <div> 
          <span class="label">Verified by</span> <br>
          <span class="bolder">{{pendingTransactions[0]?.verifiedBy || 'N/A'}}</span>
          
        </div>
        <div>
          <span class="label">Refill Number</span> <br>
          <span class="bolder"> {{pendingTransactions[0]?.refillNumber}}</span>
        </div>
        <div> 
          <img [src]="getLogoUrl(pendingTransactions[0]?.integrationType)" class="logo" [ngClass]="cardLogoClass" alt="logo"> 
        </div>
      </div>

      <div class="drug-container">
        <div class="code">
          {{mostRecentData?.drug?.packageNdc}}
        </div>
        <div class="amend-container">
          <div>
            <div class="name">
              {{mostRecentData?.drug?.friendlyName}}
            </div>
            <div class="transaction-type">
              <app-badge [maxWidth]="'160px'" [color]="(mostRecentData | transactionBadge)?.color">
                {{(mostRecentData | transactionBadge)?.label}}: {{mostRecentData?.addedQuantity}}
              </app-badge>
              
              <ng-container *ngTemplateOutlet="locationTemplate; context: {locationName: mostRecentData?.locationName}"></ng-container>

              <div *ngIf="mostRecentData?.isOrderLineItem && !mostRecentData?.compoundTransactionID" 
                class="link"
                (click)="openOrder(mostRecentData)">
                View order
              </div>
              <div *ngIf="mostRecentData?.auditId" 
                class="link"
                (click)="openAudit(mostRecentData.auditId)">
                View audit
              </div>
              <div *ngIf="mostRecentData?.activityType === ActivityTypesEnum.Compounded || mostRecentData?.compoundTransactionID" 
                class="link"
                (click)="openCompound(mostRecentData.compoundTransactionID || mostRecentData.id)">
               View Compound
              </div>
            </div>
          </div>
          <app-button *ngIf="!amendForbiddenOperationActivities.includes(widgetData?.history[0]?.activityType) && !mostRecentData.compoundTransactionID "
                      styleClass="settings"
                      subStyle="blue"
                      text="Amend"
                      class="amend-btn"
                      icon="icon-edit-pencil-active"
                      (clicked)="openAmendDialog()"
          >
          </app-button>
        </div>
      </div>

      <div class="record-details-container" *ngIf="(widgetData$ | async)">
        <div *ngIf="mostRecentData?.startingQuantity || mostRecentData?.endingQuantity"
             class="details-row"
        >
          <div class="details-item">
            <div class="label">
              Starting Count
            </div>
            <div class="data">
              {{mostRecentData?.startingQuantity | number}}
            </div>
          </div>
          <div class="details-item">
            <div class="label">
              After Count {{ (mostRecentData.activityType === ActivityTypesEnum.Amendment ? "(Amended)" : "")}}
            </div>
            <div class="data">
              {{mostRecentData?.endingQuantity | number}}
            </div>
          </div>
        </div>
        <div class="details-row" *ngIf="mostRecentData?.isOrderLineItem">
          <div class="details-item">
            <div class="label">
              {{orderDetails?.header1}}
            </div>
            <div class="data">
              {{orderDetails?.value1}}
            </div>
          </div>
          <div class="details-item">
            <div class="label">
             {{orderDetails?.header2}}
             
            </div>
            <div class="data">
              {{orderDetails?.value2}}
            </div>
          </div>
        </div>

        <div class="details-row" *ngIf="mostRecentData?.isOrderLineItem && mostRecentData?.alibi">
          <div class="single-item">
            <div class="label">
              Witness
            </div>
            <div class="data">
              {{mostRecentData?.alibi}}
            </div>
            <div class="additional">
              {{mostRecentData?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
            </div>
          </div>
        </div>

        <div *ngIf="mostRecentData?.notes?.length"
             class="details-row">
          <div class="details-item !ml-0">
            <div class="label">Explanation of the discrepancy</div>
            <div *ngFor="let note of mostRecentData.notes" class="flex flex-row pt-[0.4rem]">
              <div class="note-qty"><span>{{note.adjustmentQty}}</span></div> 
              <div class="note-descr">{{note.discrepancyDetails}}</div>
            </div>
          </div>
        </div>

        <div *ngIf="mostRecentData?.rxNumber || mostRecentData?.patientName"
             class="details-row"
        >
          <div class="details-item">
            <div class="label">
              Rx Number
            </div>
            <div class="data">
              {{mostRecentData | rxNumber}}
            </div>
          </div>
          <div class="details-item">
            <div class="label">
              Patient
            </div>
            <div class="data">
              {{mostRecentData?.patientName}}
            </div>
          </div>
        </div>

        <div *ngIf="mostRecentData?.activityType === ActivityTypesEnum.Amendment"
             class="details-row"
        >
          <div class="details-item">
            <div class="label">
              Reason
            </div>
            <div class="data">
              {{mostRecentData?.reason}} <span *ngIf="mostRecentData.amendReasonOtherDescription">{{ ' - ' +  mostRecentData?.amendReasonOtherDescription}}</span>
            </div>
            <div class="additional">
              {{mostRecentData?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}} by
              {{mostRecentData?.firstName}}
              <ng-container
                *ngIf="mostRecentData?.lastName && mostRecentData?.lastName[0]">{{mostRecentData?.lastName[0]}}.
              </ng-container>
            </div>
          </div>
          <div class="details-item">
            <div class="label">
              Witness
            </div>
            <div class="data">
              {{mostRecentData?.alibi}}
            </div>
            <div class="additional">
              {{mostRecentData?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
            </div>
          </div>
        </div>

        <div *ngIf="mostRecentData?.description &&
         (mostRecentData?.activityType === ActivityTypesEnum.LostStolen ||
         mostRecentData?.activityType === ActivityTypesEnum.DamagedExpired ||
         mostRecentData?.activityType === ActivityTypesEnum.Sold)"
             class="details-row"
        >
          <div
            *ngIf="mostRecentData?.activityType === ActivityTypesEnum.LostStolen || mostRecentData?.activityType === ActivityTypesEnum.DamagedExpired"
            class="single-item"
          >
            <div class="label">
              Describe what happened
            </div>
            <div class="data">
              {{mostRecentData?.description}}
            </div>
          </div>
          <div *ngIf="widgetData?.activityType === ActivityTypesEnum.Sold"
               class="single-item"
          >
            <div class="label">
              Name and address of other provider
            </div>
            <div class="data">
              {{mostRecentData?.description}}
            </div>
          </div>
        </div>
        <div class="details-row justify-between"  *ngIf="mostRecentData?.note || mostRecentData?.isBackCountMatches !== null">
          <div class="single-item !w-[104%]" *ngIf="mostRecentData?.note">
            <div class="label">
              Note
            </div>
            <div class="data">
              {{mostRecentData.note}}
            </div>
          </div>
          <ng-container *ngTemplateOutlet="backCountTemplate; context: {mostRecentData}"></ng-container>
        </div>
      </div>
    </div>
<!-- History -->
    <div class="smooth-scroll-wrapper" #scrollWrapper>
      <div *ngIf="widgetData && widgetData.history" class="amendment-history-container">
        <div *ngFor="let transaction of widgetData.history | slice:1; let i = index; let first = first"
             #amendHistoryItems class="amendment-item"
        >
          <div class="drug-container" [class.first]="first">
            <div class="code">
              Recorded {{transaction?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
              by {{transaction?.firstName}}
              <ng-container *ngIf="transaction?.lastName && transaction?.lastName[0]">{{transaction?.lastName[0]}}.
              </ng-container>
            </div>
            <div class="amend-container">
              <div>
                <div class="name">
                  {{transaction?.drug?.friendlyName}}
                </div>
                <div class="count">
                  <app-badge [color]="(transaction | transactionBadge)?.color">
                    {{(transaction | transactionBadge)?.label}}: {{transaction?.addedQuantity}}
                  </app-badge>

                  <ng-container *ngTemplateOutlet="locationTemplate; context: {locationName: transaction?.locationName}"></ng-container>
                </div>
              </div>
            </div>
          </div>

          <div class="record-details-container">
            <!-- TODO: Hardcoded is bad - let's get some better display logic in here-->
            <div
              *ngIf="(transaction?.startingQuantity || transaction?.endingQuantity)"
              class="details-row"
            >
              <div class="details-item">
                <div class="label">
                  Starting Count
                </div>
                <div class="data">
                  {{transaction?.startingQuantity | number}}
                </div>
              </div>
              <div class="details-item">
                <div class="label">
                  After Count
                </div>
                <div class="data">
                  {{transaction?.endingQuantity | number}}
                </div>
              </div>
            </div>

            <div *ngIf="transaction?.rxNumber && transaction?.patientName && transaction?.reasonID !== 0"
                 class="details-row"
            >
              <div class="details-item">
                <div class="label">
                  Rx Number
                </div>
                <div class="data">
                  {{transaction | rxNumber}}
                </div>
              </div>
              <div class="details-item">
                <div class="label">
                  Patient
                </div>
                <div class="data">
                  {{transaction?.patientName}}
                </div>
              </div>
            </div>

            <div class="details-row" *ngIf="getOrderDetails(transaction); let orderDetails">
              <div class="details-item">
                <div class="label">
                  {{orderDetails?.header1}}
                </div>
                <div class="data">
                  {{orderDetails?.value1}}
                </div>
              </div>
              <div class="details-item">
                <div class="label">
                 {{orderDetails?.header2}}
                 
                </div>
                <div class="data">
                  {{orderDetails?.value2}}
                </div>
              </div>
            </div>

            <div class="details-row" *ngIf="transaction?.reason || transaction?.alibi">
              <div class="details-item" *ngIf="transaction?.reason">
                <div class="label">
                  Reason
                </div>
                <div class="data">
                  {{transaction?.reason}}
                </div>
                <div class="additional">
                  {{transaction?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}} by
                  {{transaction?.firstName}}
                  <ng-container *ngIf="transaction?.lastName && transaction?.lastName[0]">{{transaction?.lastName[0]}}
                    .
                  </ng-container>
                </div>
              </div>
              <div *ngIf="transaction?.alibi"
              [ngClass]="{'details-item': transaction?.reason, 'single-item': !transaction?.reason}">
                <div class="label">
                  Witness
                </div>
                <div class="data">
                  {{transaction?.alibi}}
                </div>
                <div class="additional">
                  {{transaction?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
                </div>
              </div>
            </div>

            <div *ngIf="transaction?.description &&
                 (transaction?.activityType === ActivityTypesEnum.LostStolen ||
                 transaction?.activityType === ActivityTypesEnum.DamagedExpired ||
                 transaction?.activityType === ActivityTypesEnum.Sold)"
                 class="details-row"
            >
              <div
                *ngIf="transaction?.activityType === ActivityTypesEnum.LostStolen || transaction?.activityType === ActivityTypesEnum.DamagedExpired"
                class="details-item"
              >
                <div class="label">
                  Describe what happened
                </div>
                <div class="data">
                  {{transaction?.description}}
                </div>
              </div>
              <div *ngIf="transaction?.activityType === ActivityTypesEnum.Sold"
                   class="details-item"
              >
                <div class="label">
                  Name and address of other provider
                </div>
                <div class="data">
                  {{transaction?.description}}
                </div>
              </div>
              <div class="details-item"></div>
            </div>
            <div class="details-row justify-between" *ngIf="transaction?.note || transaction?.isBackCountMatches !== null">
              <div class="single-item !w-[104%]" *ngIf="transaction?.note">
                <div class="label">
                  Note
                </div>
                <div class="data">
                  {{transaction.note}}
                </div>
              </div>
              <ng-container *ngTemplateOutlet="backCountTemplate; context: {mostRecentData: transaction}"></ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="recent-activity-container"
           [class.with-history]="(widgetHistory$ | async) && (widgetHistory$ | async).length"
           *ngIf="(widgetHistory$ | async) && (widgetHistory$ | async).length"
      >
        <div class="recent-activity-header">
          <div class="header">
            Recent Activity
            <div class="sub-header">
              for {{widgetData?.drug.friendlyName}}
            </div>
          </div>
        </div>
      </div>

      <div class="activity-table" *ngIf="(widgetHistory$ | async) && (widgetHistory$ | async).length">
        <table class="table-primary">
          <thead>
          <tr>
            <th class="text-left recorded" scope="col">Date/Time</th>
            <th class="text-left activity" scope="col">Activity</th>
            <th class="text-left location" scope="col" *ngIf="inventoryLocationsEnabled">Location</th>
            <th class="text-right starting" scope="col">Starting</th>
            <th class="text-right count" scope="col">Count</th>
            <th class="text-right max-content-nowrap" scope="col">On-hand</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of (widgetHistory$ | async)">
            <td class="text-left recorded">
              <div class="heading">
                {{row.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}} <br>
              </div>
              <div class="secondary">
                {{row.firstName}}
                <ng-container *ngIf="row.lastName && row.lastName[0]">{{row.lastName[0]}}.</ng-container>
              </div>
            </td>
            <td class="text-left activity">
              <app-badge [color]="(row | transactionBadge)?.color">
                {{(row | transactionBadge)?.label}}
              </app-badge>
            </td>
            <td class="text-left location" *ngIf="inventoryLocationsEnabled">
             {{row?.locationName}}
            </td>
            <td class="text-right starting">{{row.startingQuantity}}</td>
            <td class="text-right count">{{row.addedQuantity}}
              <app-discrepancy-info-with-tooltip *ngIf="row?.notes?.length" class="mr-[-24px] ml-[5px]"
              [data]="{notes: row?.notes}" [tooltipWidth]="200" 
              [tooltipPosition]="{bottom: {x: '-96px', y: '22px'}}">
              </app-discrepancy-info-with-tooltip>
            </td>
            <td class="text-right on-hand">{{row.endingQuantity}}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="table-controls">
        <button *ngIf="(widgetHistoryHasMore$ | async)" (click)="openRecentActivity(widgetData.drug.id)"
                class="table-payload-btn">
          View All
        </button>
      </div>
    </div>
  </div>
</div>

<app-amend-dialog *ngIf="showAmendingDialog"
  [show]="true"
  (cancel)="cancelAmend()"
  (amend)="openPinDialog($event)"
  (compoundAmend)="openPinDialog($event)"
  [transaction]="widgetData"
  [originalTransactionId]="mostRecentData.id"
></app-amend-dialog>

<app-enter-pin-dialog #pinUser
                      [show]="showPinDialog"
                      [focusPin]="focusPin"
                      (cancel)="closePinDialog()"
                      (setPinHandler)="afterPinHandled($event)"
                      (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-enter-pin-dialog #pinWitness
                      [show]="showWitnessPinDialog"
                      [isWitness]="true"
                      (cancel)="closeWitnessPinDialog()"
                      (setPinHandler)="afterWitnessPinHandled($event)"
                      (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-reset-pin-dialog [show]="showResetPinDialog"
                      (cancel)="closeResetPinDialog()"
                      (afterUpdate)="afterPinUpdated($event)"
></app-reset-pin-dialog>

<app-enter-pin-dialog #updateTransactionDatePinUser
                      [show]="showUpdateTransactionPinDialog"
                      [focusPin]="focusPin"
                      (cancel)="closePinDialog()"
                      (setPinHandler)="afterUpdateTransactionDatePinHandled($event)"
                      (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-transaction-date-change-history *ngIf="displayTransactionDateHistory && (transactionDateChangeHistory$ | async)?.history?.length"
  [history]="(transactionDateChangeHistory$ | async)?.history"
  (closed)="displayTransactionDateHistory = false">
</app-transaction-date-change-history>

<ng-template  #locationTemplate let-locationName="locationName">
 <div class="location-container"  *ngIf="inventoryLocationsEnabled">
  <div class="label">
    Location:
  </div>
  <div>
    {{locationName}}
  </div>
 </div>
</ng-template>

<ng-template #backCountTemplate let-mostRecentData="mostRecentData">
  <div class="single-item" *ngIf="mostRecentData?.isBackCountMatches !== null">
    <div class="label">
      Back-count OK?
    </div>
    <div class="data">
      {{mostRecentData.isBackCountMatches ? 'Yes' : 'No'}}
    </div>
  </div>
</ng-template>